const DEFAULT_LOCALE = 'en-US';

const toNumericValue = (value: number | string): number | null => {
	if (typeof value === 'number') {
		return Number.isFinite(value) ? value : null;
	}

	const trimmed = value.trim();
	if (!trimmed) return null;

	const numericValue = Number(trimmed);
	return Number.isNaN(numericValue) ? null : numericValue;
};

/**
 * Formats numeric values for display (thousands separators).
 * Do not use for IDs, phone numbers, codes, or editable form field values.
 */
export const formatNumber = (value: number | string | null | undefined, options?: Intl.NumberFormatOptions): string => {
	if (value === null || value === undefined || value === '') {
		return '-';
	}

	const numericValue = toNumericValue(value);
	if (numericValue === null) {
		return String(value);
	}

	return new Intl.NumberFormat(DEFAULT_LOCALE, {
		maximumFractionDigits: 2,
		...options,
	}).format(numericValue);
};

/** Whole numbers only (counts, coins, quantities, tab badges). */
export const formatInteger = (value: number | string | null | undefined): string =>
	formatNumber(value, { maximumFractionDigits: 0 });

/** Like formatInteger but returns empty string for empty input (forms). */
export const formatIntegerForInput = (value: number | string | null | undefined): string => {
	if (value === null || value === undefined || value === '') {
		return '';
	}

	return formatInteger(value);
};

/** Strip non-digits from user input; keeps form/API payloads numeric. */
export const parseIntegerInput = (value: string): string => value.replace(/\D/g, '');
